import React from "react";
import abimg from "../../images/about - aloca.jpg";
import spimg1 from "../../images/ab-shape-1.png";

const AboutAloca = (props) => {
  return (
    <section className={`wpo-about-section ${props.abClass}`}>
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-12">
            <div className="wpo-about-wrap">
              <div className="wpo-about-img d-flex justify-content-center">
                <img src={abimg} alt="" />
                <div className="wpo-ab-shape-1">
                  <img src={spimg1} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-12 d-flex justify-content-center">
            <div className="wpo-about-text">
              <div className="wpo-about-icon-content ">
                <h2 className="p-0 ms-0 mt-0 mb-2 me-2 text-start mb-3">
                  Conectamos talentos às melhores oportunidades.
                </h2>
                <h3 className="fw-light fs-3">
                  Atuamos de forma estratégica para alocar profissionais em
                  projetos alinhados aos seus perfis e objetivos de carreira.
                  Acreditamos em processos humanizados, ágeis e eficientes,
                  e também o desenvolvimento contínuo de cada talento. Nosso 
                  compromisso é transformar trajetórias profissionais e impulsionar 
                  histórias de sucesso em grandes empresas.
                </h3>
                <a
                  href="https://wa.me/5511988799979?text=Ol%C3%A1!%20Gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20os%20servi%C3%A7os%20da%20Thomas%20Talent."
                  target="_blank"
                  rel="noreferrer"
                  className="btn theme-btn mt-3"
                >
                  Saiba mais
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutAloca;
